(function () {
  var MONTHS_FR = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];

  function parseISO(str) {
    var parts = str.split('-').map(Number);
    return new Date(parts[0], parts[1] - 1, parts[2]);
  }

  function toISO(date) {
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, '0');
    var d = String(date.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + d;
  }

  function formatFR(date) {
    return date.getDate() + ' ' + MONTHS_FR[date.getMonth()];
  }

  function addBusinessDays(start, days, holidays) {
    var date = new Date(start.getTime());
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      var dow = date.getDay();
      var iso = toISO(date);
      if (dow !== 0 && dow !== 6 && holidays.indexOf(iso) === -1) {
        added++;
      }
    }
    return date;
  }

  function init(el) {
    var today = parseISO(el.dataset.today);
    var prep = parseInt(el.dataset.prep, 10) || 0;
    var min = parseInt(el.dataset.min, 10) || 0;
    var max = parseInt(el.dataset.max, 10) || 0;
    var holidays = (el.dataset.holidays || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);

    var shipDate = prep > 0 ? addBusinessDays(today, prep, holidays) : today;
    var deliveryMin = addBusinessDays(shipDate, min, holidays);
    var deliveryMax = addBusinessDays(shipDate, max, holidays);

    var orderEl = el.querySelector('[data-role="order"]');
    var shipEl = el.querySelector('[data-role="ship"]');
    var deliveryEl = el.querySelector('[data-role="delivery"]');

    if (orderEl) orderEl.textContent = formatFR(today);
    if (shipEl) shipEl.textContent = formatFR(shipDate);
    if (deliveryEl) {
      deliveryEl.textContent = formatFR(deliveryMin) + ' au ' + formatFR(deliveryMax);
    }
  }

  document.querySelectorAll('.tm-shipping').forEach(init);
})();
